import { createContext, useContext } from 'react';

import useAutoCallFeature from '@/app/mutations/Shared/useAutoCallFeature';

export interface Transcription {
  isTranscribing: boolean;
  start(): void;
  stop(): void;
}

export const TranscriptionContext = createContext<Transcription>(null!);

export function useTranscription() {
  return useContext(TranscriptionContext);
}

export function useAutoTranscription({ joined }: { joined: boolean }, isEnabled: boolean) {
  const transcription = useTranscription();
  useAutoCallFeature(
    { joined, isEnabled },
    { isActive: transcription.isTranscribing, start: transcription.start, stop: transcription.stop },
  );
}
